<template>
  <main class="account-profile container-fluid mt-3 bg-white">
    <div class="row h-100 no-gutters pt-5">
      <div class="col-12 mx-lg-auto">
        <div
          class="row no-gutters justify-content-center align-content-start align-content-lg-stretch h-100"
        >
          <div class="col-12 col-xl-2 col-md-3 pt-lg-6 border-right">
            <pc-side-nav/>
          </div>

          <div class="col-12 col-lg mb-3 mb-lg-5 pt-6">
            <section id="myinfo-section" class="mb-5 container-fluid">
              <div id="myinfo-heading" class="d-flex mb-4 pb-1 border-bottom">
                <p class="font-weight-normal text-uppercase">
                  {{ $resourceString["account.Info.Label"] }}
                </p>
                <ul class="nav">
                  <li class="nav-item ml-2">
                    <a :href="editPersonalInfoUrl">
                      {{ $resourceString["account.Info.Edit.Label"] }}
                    </a>
                  </li>
                </ul>
              </div>
              <div class="row">
                <div class="col">
                  <p>
                    <b>
                      {{ $resourceString["account.Info.Name.Label"] }}
                    </b>
                    <br />
                    {{
                      (user.title ? user.title : "") +
                        " " +
                        user.firstName +
                        " " +
                        user.lastName
                    }}
                  </p>
                  <p>
                    <b>
                      {{ $resourceString["account.Info.Occupation.Label"] }}
                    </b>
                    <br />
                    {{ user.occupation }}
                  </p>
                </div>
                <div class="col">
                  <p>
                    <b>
                      {{ $resourceString["account.Info.Company.Label"] }}
                    </b>
                    <br />
                    {{ user.company }}
                  </p>
                  <p>
                    <b>
                      Industry Type
                    </b>
                    <br />
                    {{ user.industryType }}
                  </p>

                </div>
              </div>
            </section>

            <section id="myaddress-section" class="mb-5 container-fluid">
              <div id="myaddress-heading" class="d-flex mb-4 pb-1 border-bottom">
                <p class="font-weight-normal text-uppercase">
                  My Address
                </p>
                <ul class="nav">
                  <li class="nav-item ml-2">
                    <a :href="editAddressUrl">
                      {{ $resourceString["account.Info.Edit.Label"] }}
                    </a>
                  </li>
                </ul>
              </div>
              <div class="row">
                <div class="col">
                  <p>
                    <b>
                      {{ $resourceString["account.Info.Address.Label"] }}
                    </b>
                    <br />
                    {{ useraddress.addressLine1 }}
                    <br />
                    <span v-if="useraddress.addressLine2">
                      {{ useraddress.addressLine2 }}
                      <br />
                    </span>
                    {{
                      useraddress.city + ", " +
                      useraddress.stateProvince + ", " +
                      useraddress.postalCode
                    }}
                    <br />
                    {{ useraddress.country }}
                    <br />
                  </p>
                </div>
                <div class="col">
                  <p>
                    <b>
                      {{ $resourceString["account.Info.PhoneNumber.Label"] }}
                    </b>
                    <br />
                    {{ user.phone }}
                  </p>
                </div>
              </div>
            </section>

            <section id="logininfo-section" class="mb-5 container-fluid">
              <div id="logininfo-heading"
                   class="d-flex mb-4 pb-1 border-bottom">
                <p class="font-weight-normal text-uppercase">
                  {{ $resourceString["account.Info.Login.Label"] }}
                </p>
              </div>
              <div class="row">
                <div class="col">
                  <p>
                    <b>
                      {{ $resourceString["account.Info.Email.Label"] }}
                    </b>
                    <!--Leave the following commented for now-->
                    <!--<span class="nav-item ml-2">
                      <a :href="changeEmail">
                         $resourceString["account.Info.ChangeEmail.Label"] 
                      </a>
                    </span>-->
                    <br />
                    {{ user.email }}
                  </p>
                </div>
                <div class="col">
                  <p>
                    <b>
                      {{ $resourceString["account.Info.Password.Label"] }}
                    </b>
                    <span class="nav-item ml-2">
                      <a :href="resetPassword">
                        {{ $resourceString["account.Info.ResetPassword.Label"] }}
                      </a>
                    </span>
                    <br />
                    {{ $resourceString["account.Info.PasswordHash.Label"] }}
                  </p>
                </div>
              </div>
            </section>
            <section id="logininfo-section" class="mb-5 container-fluid">
              <div id="logininfo-heading"
                   class="d-flex mb-4 pb-1 border-bottom">
                <p class="font-weight-normal text-uppercase">
                  {{ $resourceString["account.Info.CommsPrefs.Label"] }}
                </p>
                <ul class="nav">
                  <li class="nav-item ml-2">
                    <a :href="editCommsPrefsUrl">
                      {{ $resourceString["account.Info.Edit.Label"] }}
                    </a>
                  </li>
                </ul>
              </div>
              <div class="row">
                <div class="col">
                  <p>
                    <b>
                      {{ $resourceString["account.Info.SubscribeToEmails.Label"] }}
                    </b>
                    <br />
                    {{ user.subscribeToEmails }}
                  </p>
                </div>
                <div class="col">
                  <p>
                    <b>
                      {{ $resourceString["account.Info.EmailSegmentInterests.Label"] }}
                    </b>
                    <br />
                    {{ user.emailSubscriptions }}
                  </p>
                </div>
              </div>
            </section>
            <section id="logininfo-section" class="mb-5 container-fluid">
              <div id="logininfo-heading"
                   class="d-flex mb-4 pb-1 border-bottom">
                <p class="font-weight-normal text-uppercase">
                  {{ $resourceString["account.Info.CurrentProjectInfo.Label"] }}
                </p>
                <ul class="nav">
                  <li class="nav-item ml-2">
                    <a :href="editProjectUrl">
                      {{ $resourceString["account.Info.Edit.Label"] }}
                    </a>
                  </li>
                </ul>
              </div>
              <div class="row">
                <div class="col">
                  <p>
                    <b>
                      {{ $resourceString["account.Info.CurrentProjectName.Label"] }}
                    </b>
                    <br />
                    {{ user.currentProjectName }}
                  </p>
                  <p>
                    <b>
                      {{ $resourceString["account.Info.CurrentProjectPhase.Label"] }}
                    </b>
                    <br />
                    {{ user.currentProjectPhase }}
                  </p>
                  <p>
                    <b>
                      {{ $resourceString["account.Info.CurrentProjectBudget.Label"] }}
                    </b>
                    <br />
                    {{ user.currentProjectBudget }}
                  </p>
                </div>
                <div class="col">
                  <p>
                    <b>
                      {{ $resourceString["account.Info.CurrentProjectSegment.Label"] }}
                    </b>
                    <br />
                    {{ user.currentProjectSegment }}
                  </p>
                  <p>
                    <b>
                      {{ $resourceString["account.Info.CurrentProjectDetails.Label"] }}
                    </b>
                    <br />
                    {{ user.currentProjectDetails }}
                  </p>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import PcSideNav from "../my-trays-page/pc-side-nav.vue";

export default {
  props: ["user", "useraddress"],
  data() {
    return {
      editPersonalInfoUrl: "Account/EditPersonalInfo?returnUrl=Account",
      editAddressUrl: "Account/EditAddress?returnUrl=Account",
      editCommsPrefsUrl: "Account/EditCommsPrefs?returnUrl=Account",
      editProjectUrl: "Account/EditCurrentProject?returnUrl=Account",
      resetPassword: "Account/ChangePassword?returnUrl=Account",
      changeEmail: "Account/ChangeEmail?returnUrl=Account"
    };
  },
  components: {
    PcSideNav
  }
};
</script>
